module.exports = __webpack_public_path__ + "img/weibiaoti-3.13cd0a32.png";